/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { motion as m, AnimatePresence } from "framer-motion";
import { LogOut, ChevronDown } from "lucide-react";
import AdminLogo from "./AdminLogo"; // Impor komponen baru

const AdminSidebar = ({
  isSidebarOpen,
  setIsSidebarOpen,
  menuItems,
  activeTab,
  setActiveTab,
}) => {
  const [openMenus, setOpenMenus] = useState({ "master-data": true });

  const toggleSubMenu = (id) => {
    setOpenMenus((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <>
      <AnimatePresence>
        {isSidebarOpen && window.innerWidth < 1024 && (
          <m.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setIsSidebarOpen(false)}
            className="fixed inset-0 bg-black/50 z-50 backdrop-blur-sm lg:hidden"
          />
        )}
      </AnimatePresence>

      <m.aside
        initial={false}
        animate={{
          width: isSidebarOpen ? "260px" : (window.innerWidth < 1024 ? "0px" : "80px"),
          x: window.innerWidth < 1024 && !isSidebarOpen ? -260 : 0,
        }}
        className="bg-stone-900 text-stone-300 flex flex-col fixed h-full z-50 shadow-xl overflow-hidden transition-all duration-300"
      >
        {/* PENGGUNAAN KOMPONEN LOGO BARU */}
        <AdminLogo isSidebarOpen={isSidebarOpen} />

        <nav className="flex-1 mt-4 px-3 space-y-1 overflow-y-auto hide-scrollbar">
          {menuItems.map((item) => {
            const hasChildren = item.children && item.children.length > 0;
            const isOpen = openMenus[item.id];
            const isActive = activeTab === item.id || (hasChildren && item.children.some(c => c.id === activeTab));

            return (
              <div key={item.id} className="w-full">
                <button
                  onClick={() => {
                    if (hasChildren) {
                      toggleSubMenu(item.id);
                      if (!isSidebarOpen) setIsSidebarOpen(true);
                    } else {
                      setActiveTab(item.id);
                      if (window.innerWidth < 1024) setIsSidebarOpen(false);
                    }
                  }}
                  className={`w-full flex items-center p-3 rounded-xl transition-all group ${
                    isActive ? "bg-stone-800 text-white" : "hover:bg-stone-800 hover:text-white"
                  }`}
                >
                  <div className={`shrink-0 ${isActive ? "text-amber-500" : ""}`}>{item.icon}</div>
                  <span className={`ml-4 font-medium text-sm whitespace-nowrap flex-1 text-left transition-opacity duration-300 ${
                      !isSidebarOpen && window.innerWidth >= 1024 ? "lg:opacity-0" : "opacity-100"
                  }`}>
                    {item.name}
                  </span>
                  {hasChildren && isSidebarOpen && (
                    <m.div animate={{ rotate: isOpen ? 180 : 0 }}>
                      <ChevronDown size={14} className="text-stone-500" />
                    </m.div>
                  )}
                </button>

                <AnimatePresence>
                  {hasChildren && isOpen && isSidebarOpen && (
                    <m.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      className="overflow-hidden pl-10 pr-2 mt-1 space-y-1"
                    >
                      {item.children.map((child) => (
                        <button
                          key={child.id}
                          onClick={() => {
                            setActiveTab(child.id);
                            if (window.innerWidth < 1024) setIsSidebarOpen(false);
                          }}
                          className={`w-full flex items-center p-2.5 rounded-lg text-xs transition-all ${
                            activeTab === child.id ? "text-amber-500 font-black bg-white/5" : "text-stone-500 hover:text-white"
                          }`}
                        >
                          {child.name}
                        </button>
                      ))}
                    </m.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </nav>
      </m.aside>
    </>
  );
};

export default AdminSidebar;